import React from 'react';

import { Stack } from '@mui/material';

import ChangeTierSection from './ChangeTierSection';

export default function LoyaltyOperationsPage() {
  return (
    <Stack spacing={3} maxWidth={620}>
      <ChangeTierSection />
    </Stack>
  );
}
